<template>
  <a 
    v-if="socialLinks.social_whatsapp && socialLinks.social_whatsapp.trim() !== ''"
    :href="`https://wa.me/${socialLinks.social_whatsapp.replace(/\D/g,'')}`" 
    target="_blank" 
    rel="noopener noreferrer"
    class="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
    aria-label="Chat on WhatsApp"
  >
    <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.031 0C5.385 0 0 5.383 0 12.029c0 2.124.553 4.197 1.603 6.023L.194 24l6.095-1.599A11.964 11.964 0 0012.031 24c6.646 0 12.03-5.383 12.03-12.029C24.061 5.383 18.677 0 12.031 0zm3.906 17.208c-.168.473-.976.901-1.408.966-.431.066-1.002.164-3.235-.758-2.678-1.107-4.385-3.858-4.52-4.041-.133-.182-1.077-1.432-1.077-2.731 0-1.299.673-1.94.912-2.197.239-.257.519-.321.692-.321.173 0 .346.001.503.008.163.008.383-.064.598.455.225.545.762 1.861.83 1.996.068.136.113.295.026.469-.086.173-.131.284-.263.441-.131.159-.276.331-.397.469-.13.149-.268.311-.116.574.152.261.677 1.118 1.455 1.81.998.887 1.848 1.166 2.122 1.303.272.136.432.113.593-.066.16-.182.69-1.066.877-1.432.186-.363.373-.306.626-.216.252.091 1.593.751 1.866.886.273.136.455.205.52.321.064.113.064.654-.105 1.127z"/>
    </svg>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WhatsAppFloat',
  computed: {
    ...mapGetters('settings', ['socialLinks'])
  }
}
</script>
